import WeaLocaleProvider from "../../wea-locale-provider";
import { desensitization, encryption, Encry } from "../../wea-tools/Encry.base";
const getLabel = WeaLocaleProvider.getLabel;

const text = (item, field) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  return text;
};
let timeout = null;
class main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { datas, inputId, inputTop, inputBottom } = this.props;
    this.dataObj = {};
    let list = [];
    if (inputId) {
      list = datas.map((item, index) => {
        item.id = item[inputId]; //我的请求

        this.dataObj[item.id] = item;
        let top = [];
        let bottom = [];
        inputTop &&
          inputTop.forEach(field => {
            const value = text(item, field);
            if (desensitization(value) || encryption(value)) {
              top.push(<Encry style={{ marginRight: "5px" }} value={value} />);
            } else {
              top.push(
                <span
                  style={{ marginRight: "5px" }}
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              );
            }
          });
        inputBottom &&
          inputBottom.forEach(field => {
            const value = text(item, field);
            if (desensitization(value) || encryption(value)) {
              bottom.push(
                <Encry style={{ marginRight: "5px" }} value={value} />
              );
            } else {
              bottom.push(
                <span
                  style={{ marginRight: "5px" }}
                  dangerouslySetInnerHTML={{ __html: text(item, field) }}
                />
              );
            }
          });
        return (
          <li
            ecId={`${this.props.ecId}_li@w81j8b@${index}`}
            className={this.cls(item)}
            onDoubleClick={this.onDoubleClick.bind(this, item)}
            onClick={this.onClick.bind(this, item)}
          >
            <div className="item-wrap wea-f12">
              <div className="item-top">{top}</div>
              <div className="item-bottom">{bottom}</div>
            </div>
            <div className="icon-wrap" />
            <i className="icon-coms-Selected" />
          </li>
        );
      });
    }
    return (
      <div className="wea-crm-list">
        <ul className="wea-crm-list-wrapper">{list}</ul>
        {list.length == 0 && (
          <div
            className="empty-tip"
            style={{ color: "#999", paddingTop: 30, textAlign: "center" }}
          >
            {getLabel(83320, "没有可显示的数据")}
          </div>
        )}
      </div>
    );
  }

  cls(item) {
    const { selectedKeys, filterData, inputId } = this.props;
    let cls = [];
    if (selectedKeys && selectedKeys.indexOf(item.id) > -1) {
      cls.push("selected");
    }
    if (
      filterData &&
      filterData.filter(d => d[inputId] === item.id).length > 0
    ) {
      cls.push("hide");
    }
    return cls.join(" ");
  }
  onClick(data) {
    if (data.isDevModule) {
      let { selectedKeys } = this.props;
      let keys = selectedKeys ? [...selectedKeys] : [];
      let datas = [];
      keys.forEach(k => {
        this.dataObj[k] && datas.push(this.dataObj[k]);
      });
      this.props.onClick && this.props.onClick(keys, datas, data);
      return;
    }
    let _this = this;
    // 取消上次延时未执行的方法
    clearTimeout(timeout);
    //执行延时
    timeout = setTimeout(function() {
      let { selectedKeys } = _this.props;
      let keys = selectedKeys ? [...selectedKeys] : [];
      let datas = [];
      if (keys.indexOf(data.id) > -1) {
        keys = keys.filter(k => k !== data.id);
      } else {
        keys.push(data.id);
      }
      keys.forEach(k => {
        _this.dataObj[k] && datas.push(_this.dataObj[k]);
      });
      _this.props.onClick && _this.props.onClick(keys, datas, data);
    }, 200);
  }
  onDoubleClick(data) {
    if (data.isDevModule) {
      return;
    }
    clearTimeout(timeout);
    this.props.onDoubleClick && this.props.onDoubleClick([data]);
  }
}

export default main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/components/WeaTableLeft.js